<div class="dlg-container" (click)="$event.stopPropagation()">
    <div class="dlg-contents">
        <div class="dlg-title" *ngIf="data.title">
            {{ data.title | translate }}
        </div>
        <div class="dlg-description" [class.no-margin]="!data.title">
            {{ data.description | translate }}
        </div>
        <div class="dlg-buttons">
            <button (click)="cancel()" [class.primary]="!data.isDelete" [class.delete-cancel]="data.isDelete">
                {{ data.cancelText || 'dlg.cancel' | translate }}
            </button>
            <button
                data-cy="ops-settings-duty-engrs-modal-confirm-button"
                (click)="confirm()"
                [class.white]="!data.isDelete"
                [class.delete-confirm]="data.isDelete">
                {{ data.confirmText || 'dlg.confirm' | translate }}
            </button>
        </div>
    </div>
</div>
